/**
 * What the review panel should tell the user about a run that did not check
 * everything it was asked to.
 *
 * The review worker stores "Couldn't check: <criteria>. Run again." on the run
 * when one or more criteria failed after their retry. A run with that note and
 * no findings is NOT a clean result, and must never be shown as one.
 *
 * Only that note is shown verbatim. Any other stored text ("timeout_reaper",
 * "cancelled by user", a raw exception) is internal, so a failed run without
 * the note gets a plain "didn't finish" line instead, and a complete run
 * without it gets nothing.
 */

export const COULD_NOT_CHECK_PREFIX = "Couldn't check:"
export const RUN_DID_NOT_FINISH = "This check didn't finish. Run again."

interface RunLike {
  status: 'running' | 'complete' | 'failed'
  errorMessage: string | null
}

export function reviewRunNotice(run: RunLike | null | undefined): string | null {
  if (!run || run.status === 'running') return null
  const message = run.errorMessage?.trim() ?? ''
  const named = message.startsWith(COULD_NOT_CHECK_PREFIX) ? message : null
  if (run.status === 'complete') return named
  return named ?? RUN_DID_NOT_FINISH
}
